import { render, staticRenderFns } from "./GridOrdersModal.vue?vue&type=template&id=f6bf2cac&scoped=true"
import script from "./GridOrdersModal.vue?vue&type=script&lang=js"
export * from "./GridOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./GridOrdersModal.vue?vue&type=style&index=0&id=f6bf2cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bf2cac",
  null
  
)

export default component.exports